export const AllRoutes = {
  home: '/',
  addAccount: '/addAccount',
  facturas: '/consignment',
  y2023: '/y2023',
};
